/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { ServiceType } from 'app/shared/model/enumerations/service-type.model';
import { SubscriptionType } from 'app/shared/model/enumerations/subscription-type.model';
import { Period } from 'app/shared/model/enumerations/period.model';
import { createEntity, getEntity, reset, updateEntity } from './subscription-plan.reducer';

export const SubscriptionPlanUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const subscriptionPlanEntity = useAppSelector(state => state.subscriptionPlan.entity);
  const loading = useAppSelector(state => state.subscriptionPlan.loading);
  const updating = useAppSelector(state => state.subscriptionPlan.updating);
  const updateSuccess = useAppSelector(state => state.subscriptionPlan.updateSuccess);
  const serviceTypeValues = Object.keys(ServiceType);
  const subscriptionTypeValues = Object.keys(SubscriptionType);
  const periodValues = Object.keys(Period);

  const handleClose = () => {
    navigate(`/subscription-plan${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.amount !== undefined && typeof values.amount !== 'number') {
      values.amount = Number(values.amount);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...subscriptionPlanEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          serviceType: 'PHARMACY_STORE',
          subscriptionType: 'BETA',
          period: 'MONTHLY',
          ...subscriptionPlanEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.subscriptionPlan.home.createOrEditLabel" data-cy="SubscriptionPlanCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.subscriptionPlan.home.createOrEditLabel">Create or edit a SubscriptionPlan</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="subscription-plan-id"
                  label={translate('tinyMedicRestApp.subscriptionPlan.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionPlan.serviceType')}
                id="subscription-plan-serviceType"
                name="serviceType"
                data-cy="serviceType"
                type="select"
              >
                {serviceTypeValues.map(serviceType => (
                  <option value={serviceType} key={serviceType}>
                    {translate(`tinyMedicRestApp.ServiceType.${serviceType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionPlan.subscriptionType')}
                id="subscription-plan-subscriptionType"
                name="subscriptionType"
                data-cy="subscriptionType"
                type="select"
              >
                {subscriptionTypeValues.map(subscriptionType => (
                  <option value={subscriptionType} key={subscriptionType}>
                    {translate(`tinyMedicRestApp.SubscriptionType.${subscriptionType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionPlan.period')}
                id="subscription-plan-period"
                name="period"
                data-cy="period"
                type="select"
              >
                {periodValues.map(period => (
                  <option value={period} key={period}>
                    {translate(`tinyMedicRestApp.Period.${period}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionPlan.amount')}
                id="subscription-plan-amount"
                name="amount"
                data-cy="amount"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionPlan.active')}
                id="subscription-plan-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionPlan.lastupdated')}
                id="subscription-plan-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionPlan.microSec')}
                id="subscription-plan-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionPlan.timestampentry')}
                id="subscription-plan-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.subscriptionPlan.cursor')}
                id="subscription-plan-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/subscription-plan" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SubscriptionPlanUpdate;
